/**
 * CheckboxCell Component
 *
 * Renders a simple checkbox toggle.
 */

import type { CheckboxCellProps } from './types';

export function CheckboxCell({
  value,
  onChange,
  readonly = false,
}: CheckboxCellProps) {
  const isChecked = value?.checked ?? false;

  const handleToggle = () => {
    if (readonly || !onChange) return;
    onChange({ checked: !isChecked });
  };

  return (
    <div className="w-full h-full flex items-center justify-center">
      <input
        type="checkbox"
        checked={isChecked}
        onChange={handleToggle}
        disabled={readonly}
        className={`
          h-5 w-5 rounded border-gray-300 text-primary-500
          focus:ring-primary-500 focus:ring-offset-0
          ${readonly ? 'cursor-not-allowed opacity-60' : 'cursor-pointer'}
        `}
      />
    </div>
  );
}
